import * as type from '../ActionTypes';

const initialState = {
  recommendedJobs: [],
  loading: true,
  error: null
};

export default function getRecommendedJobs(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_ALL_RECOMMENDED_JOBS:
      return {
        ...state,
        loading: true,
        error: '',
        recommendedJobs: []
      };

    case type.GET_ALL_RECOMMENDED_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        recommendedJobs: [],
        error: action.error
      };
    case type.GET_ALL_RECOMMENDED_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        recommendedJobs: action.recommendedJobs,
        error: null
      };

    default:
      return state;
  }
}
